import { Navigate, useParams } from '@tanstack/react-router';

import { PageSpinner } from 'common/components/cookbook/PageSpinner';
import { useCountriesQuery } from 'common/hooks/useCountries';
import { useSelectedCountry } from 'common/hooks/useSelectedCountry';
import { useProductQuery } from 'features/catalog/hooks/useProductQuery';

export function RedirectProductWithoutCountry() {
  const { productId } = useParams({ strict: false });
  const { data: country, isLoading: isLoadingSelectedCountry } = useSelectedCountry();
  const { product: productQuery } = useProductQuery(productId);
  const { data: product, isLoading: isLoadingProduct } = productQuery;

  const isLoading = isLoadingSelectedCountry || isLoadingProduct;

  const countryLanguage =
    product?.countryLanguages.find((cl) => cl.countryCode === country?.countryCode) ??
    product?.countryLanguages.at(0);

  const language =
    countryLanguage?.languages.find((lang) => lang === country?.defaultLanguageCode) ??
    countryLanguage?.languages.at(0);

  if (isLoading) {
    return <PageSpinner />;
  }

  if (countryLanguage && language && product) {
    return (
      <Navigate
        replace
        to="/catalog/$productId/country/$countryCode/lang/$languageCode"
        params={{
          productId: product.id,
          countryCode: countryLanguage.countryCode,
          languageCode: language,
        }}
        search
      />
    );
  }

  return <Navigate to="/catalog" />;
}

export function RedirectProductWithoutLanguage() {
  const { countryCode, productId } = useParams({ strict: false });
  const { product: productQuery } = useProductQuery(productId);
  const { data: countries, isLoading: isLoadingCountries } = useCountriesQuery();
  const { data: product, isLoading: isLoadingProduct } = productQuery;

  const isLoading = isLoadingCountries || isLoadingProduct;

  const countryLanguage =
    product?.countryLanguages.find((cl) => cl.countryCode === countryCode) ??
    product?.countryLanguages.at(0);

  const selectedCountryDefaultLanguageCode = countries?.find(
    (country) => country.countryCode === countryCode,
  )?.defaultLanguageCode;

  const language =
    countryLanguage?.languages.find((lang) => lang === selectedCountryDefaultLanguageCode) ??
    countryLanguage?.languages.at(0);

  if (isLoading) {
    return <PageSpinner />;
  }

  if (countryLanguage && language && product) {
    return (
      <Navigate
        replace
        to="/catalog/$productId/country/$countryCode/lang/$languageCode"
        params={{
          productId: product.id,
          countryCode: countryLanguage.countryCode,
          languageCode: language,
        }}
        search
      />
    );
  }

  return <Navigate to="/catalog" />;
}
